import React from 'react';
import styled from 'styled-components';
import {Modal, message} from 'antd';
import {getNewOutlet, useOutlet} from 'reconnect.js';
import GenericForm from 'rev.sdk.js/Generic/Form';
import * as JStorage from 'rev.sdk.js/Actions/JStorage';
import AdminSelectProductWidget from '../../Generators/AdminResource/AdminSelectProductWidget';
import * as AppActions from '../../AppActions';
import {ModalCustomStyle} from '../../AppContext/customStyledCss';

getNewOutlet('AdminSearchProductPayModal', null, {autoDelete: false});

export default function AdminSearchProductPayModal(props) {
  const [modalData, setModalData] = useOutlet('AdminSearchProductPayModal');
  const [user] = useOutlet('user');

  return (
    <Modal
      title={null}
      footer={null}
      bodyStyle={{padding: 0}}
      width={640}
      visible={modalData}
      onOk={() => {
        setModalData(null);
      }}
      onCancel={() => {
        setModalData(null);
      }}
      destroyOnClose={true}>
      {user && modalData && (
        <ModalContent
          modalData={modalData}
          setModalData={setModalData}
          user={user}
        />
      )}
    </Modal>
  );
}

function ModalContent(props) {
  const {modalData, setModalData} = props;
  const {clientCallbacks} = modalData;
  const rjsfProps = {
    widgets: {
      'admin-select-product-widget': AdminSelectProductWidget,
    },
  };

  return (
    <Wrapper>
      <h2 className="title">活動/課程給付建立</h2>
      <GenericForm
        schema={{
          title: '',
          type: 'object',
          required: ['product'],
          properties: {
            product: {
              type: 'string',
              title: '',
            },
          },
        }}
        uiSchema={{
          product: {
            'ui:widget': 'admin-select-product-widget',
            'ui:options': {label: false},
          },
        }}
        rjsfProps={rjsfProps}
        onSubmit={async (formData, extValue) => {
          try {
            const product = await JStorage.fetchOneDocument('product', {
              id: formData.product,
            });

            const hasSessionPeople =
              product.session &&
              Object.keys(product.session).length > 0 &&
              product.session.people &&
              product.session.people.length > 0;

            if (hasSessionPeople) {
              const actions = product.session.people.map((person) => ({
                method: 'insert_one',
                payload: {
                  data: {
                    name: person.name,
                    content: `${product.name} ${person.type}`,
                  },
                },
              }));

              await JStorage.bulkWriteDocuments('pay_billing', actions);
              message.success('創建成功');
              clientCallbacks.refresh();
              setModalData(null);
            } else {
              message.error('該課程/活動沒有講者名單');
              clientCallbacks.refresh();
              setModalData(null);
            }
          } catch (err) {
            console.warn(err);
            message.error('創建失敗');
            AppActions.setLoading(true);
          }
        }}
      />
    </Wrapper>
  );
}

const Wrapper = styled(ModalCustomStyle)`
  padding: 20px;

  & > .title {
    margin-bottom: 10px;
  }
`;
